import axios from 'axios';
import { config } from '../config';
import { authHeader } from '../helpers';

const axiosInstance = axios.create({
  baseURL: '' // your base URL if needed
});

/// 🔥 GLOBAL RESPONSE HANDLER
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const status = error?.response?.status;

    if (status === 401) {
      localStorage.removeItem('user');

      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }

      // ✅ STOP propagation completely
      return new Promise(() => {});
    }

    return Promise.reject(error);
  }
);

export const formService = {
  submitForm
};

function submitForm(data) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeader() }
  };

  return axiosInstance
    .post(`${config.form_server}/submit`, data, requestOptions)
    .then((responce) => {
      return responce.data;
    });
}
